import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DocsLanding from "../../components/feature-docs/DocsLanding";

const DocsOpen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isNotificationDenied = useSelector(
    (state) => state.notification.permission
  );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access", { state: { from: location.pathname } });
    }
  }, [pageState]);

  return (
    <DocsLanding
      userInfoData={userInfoData}
      isCustom={isCustom}
      isIOS={isIOS}
      isNotificationDenied={isNotificationDenied}
    />
  );
};

export default DocsOpen;
